import { Controller } from "@hotwired/stimulus"
import Cleave from "cleave.js"
import currency from "currency.js"

export default class extends Controller {
  static targets = [
    "formattedPrice",      // Visible text field where user types dollars
    "hiddenCents",         // Hidden field that stores integer cents (optional)
    "grandTotalCents",     // For full-refund toggling
    "subTotalCents"
  ];

  connect() {
    this.initializeCleave()

    // If this is the "full refund" form and grandTotalCentsTarget is present,
    // set the formattedPrice field to the grand total right away.
    if (this.hasGrandTotalCentsTarget) {
      this.formattedPriceTarget.value = this.convertCentsToDollars(
        this.grandTotalCentsTarget.value
      )
    } else {
      // Otherwise, default to "$0.00" (e.g. partial refund form)
      this.formattedPriceTarget.value = "$0.00"
    }

    // Re-sync the hidden cents field (if you're using one)
    this.updateCents()
  }

  initializeCleave() {
    this.cleave = new Cleave(this.formattedPriceTarget, {
      numeral: true,
      numeralThousandsGroupStyle: 'thousand',
      numeralDecimalMark: '.',
      delimiter: ',',
      prefix: '$',
      rawValueTrimPrefix: true
    })
  }

  // Called each time the user types (input->order-refunds#updateCents)
  updateCents() {
    const rawValue = this.cleave.getRawValue() // e.g. "12.34"
    const floatValue = parseFloat(rawValue) || 0.0
    const centsValue = Math.round(floatValue * 100)

    if (this.hasHiddenCentsTarget) {
      this.hiddenCentsTarget.value = centsValue
    }
  }

  // Only the full-refund form uses this (toggle):
  // Switches between the grand_total_cents and sub_total_cents.
  toggleRefundAmount(event) {
    const checkbox = event.target
    if (checkbox.checked && this.hasSubTotalCentsTarget) {
      this.formattedPriceTarget.value = this.convertCentsToDollars(
        this.subTotalCentsTarget.value
      )
    } else if (this.hasGrandTotalCentsTarget) {
      this.formattedPriceTarget.value = this.convertCentsToDollars(
        this.grandTotalCentsTarget.value
      )
    }

    // Re-format in Cleave
    this.cleave.setRawValue(this.cleave.getRawValue())
    // Update hidden cents field
    this.updateCents()
  }

  convertCentsToDollars(cents) {
    return currency(cents, { fromCents: true }).format()
  }
}
